import { ModalStackProvider } from "@inertiaui/modal-react";
import type { ReactNode } from "react";

export function withApp(app: ReactNode) {
  return <ModalStackProvider>{app}</ModalStackProvider>;
}
